import { render, staticRenderFns } from "./BeneficiaryAccountApplying.vue?vue&type=template&id=2539294a&scoped=true"
import script from "./BeneficiaryAccountApplying.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountApplying.vue?vue&type=script&lang=js"
import style0 from "./BeneficiaryAccountApplying.vue?vue&type=style&index=0&id=2539294a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2539294a",
  null
  
)

export default component.exports